import { render, staticRenderFns } from "./SerieWallpapers.vue?vue&type=template&id=29680ecc&"
import script from "./SerieWallpapers.vue?vue&type=script&lang=js&"
export * from "./SerieWallpapers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports